export default __webpack_public_path__ + "static/media/03.42c8d4a1.jpg";